import React from "react";
import { twMerge } from "tailwind-merge";

//CSS
import "./Title.css";

//Animation
import { motion } from "framer-motion";
import { RevealVariants } from "./anims";

//Hooks
import { useTranslation } from "react-i18next";

export default function Title({
  className = "",
  children,
  textPosition = "start",
}) {
  const textPositions = ["start", "end", "center"];
  const checkedTextPosition = textPositions.includes(textPosition)
    ? textPosition
    : textPositions[0];
  const finalClassName = twMerge(
    "PageTitle container-bordered vertical w-90 mb-3 pad-s break-word font-l text-color-primary z-inherit",
    className
  );

  const { t } = useTranslation();

  return (
    <motion.h1
      initial="hiddenFade"
      whileInView="shown"
      viewport={{ once: RevealVariants.showOnce }}
      variants={RevealVariants}
      className={finalClassName}
      style={{
        justifyContent: checkedTextPosition,
      }}
    >
      {t(children)}
    </motion.h1>
  );
}
